import {http} from '../utils'
// 营销分组管理 start
// 查询
const searchAction = (params) => {
  const url = `/market/management/email/list`
  return http.post(url, params)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url,params)
}
// 获取 详情
const getAction = (params) => {
  const url = `/market/management/email/list/detail`
  return http.post(url, params)
}
// 新建
const addAction = (params) => {
  const url = `/market/management/email/list/add`
  return http.post(url, params)
}
// 新建
const editAction = (params) => {
  const url = `/market/management/email/list/edit`
  return http.post(url, params)
}
// 删除
const deleteAction = (params) => {
  const url = `/market/management/email/list/del`
  return http.post(url, params)
}

// 地址薄
const getAddressList = (params) => {
  const url = '/market/management/email/address/list'
  return http.post(url, params)
}
// 删除地址薄
const addAddressAction = (params) => {
  const url = `/market/management/email/address/list/add`
  return http.post(url, params)
}
// 清空号码
const clearAction = (params) => {
  const url = `/market/management/email/address/list/empty`
  return http.post(url, params)
}
// 删除地址薄
const deleteAddressAction = (params) => {
  const url = `/market/management/email/address/list/del`
  return http.post(url, params)
}
// 获取getResourcePool列表
const getResourcePool = (params) => {
  const url = '/market/management/resource/all'
  return http.post(url, params)
}
export default {
  searchAction,
  getGroup,
  getAction,
  addAction,
  editAction,
  deleteAction,
  getAddressList,
  addAddressAction,
  clearAction,
  deleteAddressAction,
  getResourcePool
}
